import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
  selector: 'app-add-decline-comment-dialog',
  templateUrl: './add-decline-comment-dialog.component.html',
  styleUrls: ['./add-decline-comment-dialog.component.scss']
})
export class AddDeclineCommentDialogComponent implements OnInit {

  //#region Fields
  public message: string = '';
  //#endregion

  //#region Constructor
  constructor(public ref: DynamicDialogRef) { }

  ngOnInit(): void {
  }
  //#endregion

  //#region Public Methods
  public close(decline: boolean): void {
    if (decline) {
      this.ref.close({decline, message: this.message});
    } else {
      this.ref.close({decline});
    }
  }
  //#endregion
}
